import React, { Fragment } from 'react';
import { css } from 'aphrodite/no-important';
import styles from './LoginInput.styles';

const LoginInput = props => {
  const {
    styles: customStyles,
    meta: { error, touched },
    input,
    type,
    placeholder
  } = props;
  return (
    <Fragment>
      <input
        autoFocus
        className={css(styles.base, customStyles)}
        type={type}
        placeholder={placeholder}
        {...input}
      />
      {touched && error && <span className={css(styles.error)}>{error}</span>}
    </Fragment>
  );
};

export default LoginInput;



// WEBPACK FOOTER //
// ./src/components/inputs/logininput/LoginInput.js